<template>
  <div>
    <el-upload
      ref="el-upload"
      :action="action"
      :headers="requestHeaders"
      :data="data"
      :on-remove="onRemove"
      :on-success="onSuccess"
      :before-upload="pickedFile"
      multiple
      :file-list="fileList"
      :disabled="disabled"
      :accept="accept"
    >
      <FileMediaItemHeader
        :disabled="disabled"
      >
        <slot name="title" />
      </FileMediaItemHeader>

      <FileMediaItemDescription>
        <slot name="description" />
      </FileMediaItemDescription>
    </el-upload>
    <FileMediaItemListEmptyState :file-list="fileList" />
  </div>
</template>

<script>
import Vue from 'vue';
import Upload from 'element-ui/lib/upload';
import FileMediaItemHeader from './FileMediaItemHeader';
import FileMediaItemDescription from './FileMediaItemDescription';
import FileMediaItemListEmptyState from './FileMediaItemListEmptyState';

Vue.use(Upload);

export default {
  name: 'FileMediaItem',
  components: {
    FileMediaItemHeader,
    FileMediaItemDescription,
    FileMediaItemListEmptyState,
  },
  props: {
    action: {
      type: String,
      required: true,
    },
    accept: {
      type: String,
      default: '*/*',
    },
    requestHeaders: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    onRemove: {
      type: Function,
      required: true,
    },
    onSuccess: {
      type: Function,
      required: true,
    },
    fileList: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isAcceptedType: true,
    };
  },
  methods: {
    pickedFile(rawFile) {
      const isDuplicate = this.fileList.filter(file => file.name === rawFile.name);
      const uploader = this.$refs['el-upload'].$children.find(child => child.name === 'file');
      if (isDuplicate.length > 0) {
        this.$message('This file already exist');
        this.isAcceptedType = false;
        return false;
      }
      if (this.accept.includes('image')) {
        const isImage = uploader.isImage(rawFile.type);

        if (!isImage) {
          this.$message('You can only upload images here');
        }
        this.isAcceptedType=isImage;
      } else if (this.accept.includes('video')) {
        const isVideo = rawFile.type.includes('video');

        if (!isVideo) {
          this.$message('You can only upload videos here');
        }
        this.isAcceptedType=isVideo;
      } else if (this.accept.includes('srt')) {
        const isSrtFile = rawFile.type.includes('srt');

        if (!isSrtFile) {
          this.$message('You can only upload .srt files here');
        }
        this.isAcceptedType=isSrtFile;
      }
      uploader.uploadFiles(rawFile);
      return this.isAcceptedType;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Submission/steps/FilesMedia/FileMediaItem.vue